$(function () {
    let profile = {
        updatePreferences: function () {
            let requestData = {
                'interests': [],
                'contactOptions': []
            };
            $('input[name="interests[]"]:checked').each(function () {
                requestData.interests.push($(this).val());
            });
            $('input[name="contactOptions[]"]:checked').each(function () {
                requestData.contactOptions.push($(this).val());
            });
            $.post('/actions/businessLogic/users/updateProfile', requestData, function (response) {
                //console.log(response);
            });
        }
    };

    //update profile button
    $('[data-update-profile]').click(function(e){
       e.preventDefault();
       let form = $('#user-prefs');
       let data = form.serialize();
       $this = $(this);
       console.log(data);
        Swal.fire({
            title: 'Updating preferences',
            didOpen: () => {
                Swal.showLoading()
            }
        });
       $.ajax({
            method: "POST",
            data: data,
            dataType: "json",
            success: function(data, response){
                console.log(response);
                window.alert.toast('Your preferences have been updated', 'success', {position: 'center', timer: 2000});
                // Call the callback set on the button, if exists
                if($this.data('on-success-callback') && typeof window[$this.data('on-success-callback')] == 'function'){
                    window[$this.data('on-success-callback')]();
                }
            },
            error: function(response) {
                console.log(response);
            }
        });
    });

    // On click of data view
    $('.data-view').click(function () {

        if($(this).data('password') == true) {
            $('.data-edit').hide();
            $('.data-view').show();
            let $dataEdit = $(this).next();
            $('#current-password').show();
            $dataEdit.slideToggle();
            let $input = $dataEdit.find('input');
            $input.focus();
            setTimeout(function () {
                $input.select();
            }, 100);
            return false;
        } else {
            $('.data-edit').hide();
            $('.data-view').show();
            let $dataEdit = $(this).next();
            $dataEdit.slideToggle();
            let $input = $dataEdit.find('input');
            $input.focus();
            setTimeout(function () {
                $input.select();
            }, 100);
            return false;
        }
        
    });

    // On click of "Save"
    $('.data-edit .save').click(function (event) {
        event.preventDefault();
        let form = $('#user-info');
        let pass = '';
        $('input[name="password"]').each(function(){
            if ($(this).val() != '') {
                pass = ($(this).val())
            }
        });
        $('input[name="password"]').each(function(){
            if ($(this).val() == '') {
                $(this).val(pass);
            }
        });

        let $dataEdit = $(this).parent().closest('.data-edit');
        let $dataView = $dataEdit.prev();
        let val = $dataEdit.find('input').val();
        let id = $dataEdit.attr('id');
        let requestData = {};
        requestData[id] = val;
        
        let data = form.serialize();
        /*
        $.post('/actions/businessLogic/users/updateProfile', requestData, function (response) {
            //console.log(response);
        });

        */
       console.log(data);
       $.ajax({
            method: "POST",
            data: data,
            dataType: "json",
            success: function(data, response){
                $(this).parents('.account-item').remove();
                console.log(data);
                if(data.errors){
                    if(data.errors.currentPassword) {
                        alert(data.errors.currentPassword);
                    }
                } else {
                    $dataView.find('td:nth-child(2)').text(val);
                    $dataEdit.hide();
                    $('.data-view').show();
                }
                
            },
            error: function(response) {
                console.log(response);
            }
        });
    });

    // On click of "Cancel"
    $('.data-edit .cancel').click(function (event) {
        event.preventDefault();
        $('.data-edit').hide();
        $('.data-view').show();
    });

    // On input enter or escape
    $('.data-edit input').on('keyup', function (e) {
        let $dataEdit = $(this).parents('.data-edit');
        if (13 === e.keyCode) { // Enter
            $dataEdit.find('.save').click();
        } else if (27 === e.keyCode) { // Esc
            $dataEdit.find('.cancel').click();
        }
    })
});